export const col = (name, a = 1) => `rgb(var(--${name}) / ${a})`;
export const TONE = { primary: "primary", info: "info", success: "success", warning: "warning", critical: "critical", accent: "accent" };
export const fmt = (n, d = 0) => Number(n).toLocaleString("en-PH", { maximumFractionDigits: d, minimumFractionDigits: d });
export const peso = (n) => `₱${fmt(n)}`;

// Shared SVG text style (inherits the platform font, muted colour).
export const T = { fontSize: 11, fill: col("muted") };
export const Tm = { ...T, fontFamily: "IBM Plex Mono, monospace" };
